var parent = require('../../actual/object/set-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/set-prototype-of.js
// module id = 476
// module chunks = 0 1